import { Component } from "@angular/core";

@Component({
	selector: "caass-classroom",
	templateUrl: "./classroom.component.html",
})
export class ClassroomComponent {}
